<template>
    <div class="container" v-title data-title="学生评价">
      <div class="banner">
        <div class="star-bg"></div>
        <div class="light-bg"></div>
        <div class="medal">
          <img :src="currentMedal.url" alt="" :class="`${evaluateDetail.classroomPerformance < 5 && 'no-medal'}`">
        </div>
        <span class="banner-title"></span>
        <span class="avatar">
          <img :src="evaluateDetail.avatarUrl" alt="" class="avatar-img">
        </span>
        <span class="score">{{evaluateDetail.classroomPerformance}}分</span>
        <p class="student-info">
          <span class="is-bold">“{{evaluateDetail.studentName}}”</span>
          在编程猫
          <span class="is-bold">“{{evaluateDetail.pointName}}”</span>
          <span v-if="currentMedal.name">
            课程中表现优异，获得了
          <span class="medal-name">“{{currentMedal.name}}”</span>
          </span>
          <span v-else>
             课程中表现尚可，但遗憾的和勋章失之交臂
          </span>
        </p>
      </div>
      <div class="padding-box">
        <div class="class-info">
          <span class="couple"></span>
          <div class="content-wrap">
            <p class="content" v-html="evaluateDetail.description"></p>
            <span class="pencil"></span>
          </div>
        </div>
        <div class="class-work" v-if="workList.goal.length || workList.student.length">
          <div class="square-list"></div>
          <div class="switch-tab">
            <span :class="`${currentTab === 'student' && 'active'} tab`"
                  @click="changeTab('student')"
                  v-if="workList.student.length">我的作品</span>
            <span :class="`${currentTab === 'goal' && 'active'} tab`"
                  @click="changeTab('goal')"
                  v-if="workList.goal.length">查看课例</span>
          </div>
          <div class="list-wrap">
            <ul class="work-list" :style="{width: workList[currentTab].length * 290 + 'px'}">
              <li class="work-li" v-for="(t, i) in workList[currentTab]" :key="i">
                <div class="work">
                  <div class="mask" @click="showWork(t.url)">
                    <span class="play-icon"></span>
                  </div>
                </div>
                <p class="work-name" v-if="currentTab === 'student'">
                  <span class="name-title">{{evaluateDetail.workName}}</span>
                  <span class="name">——{{evaluateDetail.studentName}}</span>
                </p>
                <p class="work-name" v-else>
                  <span class="name-title">课例{{i + 1}}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="square-list"></div>
        </div>
        <div class="create-analyze" v-if="evaluateDetail.workAnalyzeShow && JSON.stringify(evaluateDetail.eventMap) !== '{}' && evaluateDetail.codingSum">
          <div class="title">
            <i class="expression-icon"></i>
            <span class="title-desc">创作分析</span>
            <i class="word-bg"></i>
          </div>
          <div class="dashed"></div>
          <p class="analyze-content">
            本节课
            <span class="is-blue">“{{evaluateDetail.studentName}}”</span>
            的作品共新增了
            <span class="is-blue">{{evaluateDetail.codingSum}}</span>
            行代码，使用了
            <span class="is-blue">{{evaluateDetail.roleSum}}</span>
            个角色，
            <span class="is-blue">{{evaluateDetail.screenSum}}</span>
            个竖版屏幕，
            <span class="is-blue">{{evaluateDetail.cloudSum}}</span>
            次云端功能。
          </p>
          <BarChart :data="analyzeChart"></BarChart>
          <p class="avg-content">
            全班平均每人新增 {{evaluateDetail.avgCodeSum}} 行代码，您的孩子比{{parseInt((evaluateDetail.codeRank ? evaluateDetail.codeRank : 0.5) * 100)}}%的人都努力～
          </p>
        </div>
        <div class="class-expression">
          <div class="title">
            <i class="expression-icon"></i>
            <span class="title-desc">课堂表现</span>
            <i class="word-bg"></i>
          </div>
          <div class="dashed"></div>
          <div class="chart-wrap">
            <Radar
              :sourceData="chartData"
              :width="208"
              :height="252"
            />
          </div>
          <div class="expression-wrap">
            <div class="expression">
              <p class="score">{{evaluateDetail.classroomPerformance}}<span>分</span></p>
              <p class="desc">个人综合表现</p>
            </div>
            <div class="expression">
              <p class="score">{{evaluateDetail.classAveragePerformance}}<span>分</span></p>
              <p class="desc">班级综合表现</p>
            </div>
            <div class="expression">
              <p class="score">{{evaluateDetail.completeCostTime ? evaluateDetail.completeCostTime : '/'}}<span v-if="evaluateDetail.completeCostTime">分钟</span></p>
              <p class="desc">完成时长</p>
            </div>
          </div>
        </div>
        <div class="class-evaluate" v-if="evaluateDetail.teacherComment || evaluateDetail.schoolTeacherComment">
          <div class="title">
            <i class="expression-icon"></i>
            <span class="title-desc">课堂点评</span>
            <i class="word-bg"></i>
          </div>
          <div class="dashed"></div>
          <div class="evaluate-wrap">
            <div class="evaluate-detail-mlz"
                 v-if="evaluateDetail.teacherComment"
                 :style="{marginBottom: evaluateDetail.schoolTeacherComment ? '32px' : '0'}">
              <span class="mlz-evaluate">猫老祖</span>
              <p class="content" v-html="evaluateDetail.teacherComment"></p>
            </div>
            <div class="evaluate-detail-class" v-if="evaluateDetail.schoolTeacherComment">
              <span class="class-teacher-evaluate">课堂老师</span>
              <p class="content" v-html="evaluateDetail.schoolTeacherComment"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="work-wrap" v-show="showWorkFlag" @click="hiddenWork">
        <img :src="workUrl" v-if="evaluateDetail.pointPlatform === 'wood' && checkExt(workUrl) === 'image'"/>
        <iframe :src="workUrl" frameborder="0" class="work-iframe" v-else></iframe>
        <span class="word-tip">点击上下黑幕区域可关闭当前弹窗</span>
      </div>
      <div class="bottom-bg"></div>
    </div>
</template>

<script>
import { get } from '@/utils/ajax'
import Modal from '@/components/Modal'
import { WeChatShare } from '@/utils'
import Radar from '@/components/Radar'
import BarChart from '@/components/BarChart'
export default {
  components: {
    Modal,
    Radar,
    BarChart
  },
  data () {
    return {
      evaluateDetail: {},
      showWorkFlag: false,
      workUrl: '',
      chartData: [],
      currentTab: 'student',
      currentMedal: {
        name: '',
        url: ''
      },
      medalList: [
        'https://education.codemao.cn/27/public-edu/1/no-medal@2x.png',
        'https://education.codemao.cn/27/public-edu/1/康格鲁勋章@2x.png',
        'https://education.codemao.cn/27/public-edu/1/冯诺伊曼勋章@2x.png',
        'https://education.codemao.cn/27/public-edu/1/洛夫莱斯勋章@2x.png',
        'https://education.codemao.cn/27/public-edu/1/图灵勋章@2x.png'
      ],
      workList: {
        student: [],
        goal: []
      },
      analyzeChart: []
    }
  },
  mounted () {
    this.getEvaluateDetail()
  },
  methods: {
    checkExt (tempFilePaths) {
      const images = ['.jpg', '.jpeg', '.gif', '.bmp', '.png', '.webp', '.svg'] // 图片类型
      const audios = ['.mp3', '.wma', '.ogg', '.flac', '.aac', '.wav'] // 音频类型
      const videos = ['.mp4', '.avi', '.asf', '.rmvb', '.rm', '.mov', '.mkv', '.mpg', '.flv', '.m3u8', '.webm'] // 视频类型
      const bcm = ['.bcm'] // kitten文件
      const py = ['.py'] // wood文件
      const index1 = tempFilePaths.lastIndexOf('.')
      const index2 = tempFilePaths.length
      const suffix = tempFilePaths.substring(index1, index2)
      if (images.includes(suffix)) {
        return 'image'
      } else if (audios.includes(suffix)) {
        return 'audio'
      } else if (videos.includes(suffix)) {
        return 'video'
      } else if (bcm.includes(suffix)) {
        return 'bcm'
      } else if (py.includes(suffix)) {
        return 'py'
      } else {
        return 'file'
      }
    },
    replaceText (text) {
      return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
    },
    changeTab (tab) {
      this.currentTab = tab
    },
    wechatShare () {
      const shareInfo = {
        title: `${this.evaluateDetail.studentName}的${this.evaluateDetail.pointName}-课堂评价`, // 分享标题
        desc: '快来瞅瞅他的课堂表现吧！', // 分享描述
        link: window.location.href, // 分享链接，该链接域名必须与当前企业的可信域名一致
        imgUrl: 'https://public-static-edu.codemao.cn/redcandlemobile/share/share_student.png'
      }
      WeChatShare(shareInfo)
    },
    showWork (url) {
      this.showWorkFlag = true
      this.workUrl = url || `${CONFIG.player}/w/${this.evaluateDetail.workId}`
    },
    hiddenWork () {
      this.showWorkFlag = false
      this.workUrl = ''
    },
    formatNum (num, isCompleteTime) {
      let result = isCompleteTime ? (num / 60).toFixed(1).toString() : num.toFixed(1).toString()
      if (result[result.length - 1] === '0') result = result.split('.')[0]
      return Number(result)
    },
    async getEvaluateDetail () {
      const { attendanceId, studentId } = this.$route.query
      const data = await get(`${CONFIG.ai_class}/patriarch/kps-study-student-evaluate/getOneStudent`, { attendanceId, studentId })
      this.evaluateDetail = data
      if (navigator.userAgent.toLocaleLowerCase().includes('micromessenger')) this.wechatShare()
      this.chartData = [
        { item: '课堂效率', personal: this.evaluateDetail.classroomEfficiency, class: this.evaluateDetail.classEfficiency },
        { item: '注意力', personal: this.evaluateDetail.attention, class: this.evaluateDetail.classroomAttention },
        { item: '完成度', personal: this.evaluateDetail.completeDegree, class: this.evaluateDetail.classCompleteDegree }
      ]
      this.evaluateDetail.description = this.replaceText(this.evaluateDetail.description)
      if (this.evaluateDetail.teacherComment) this.evaluateDetail.teacherComment = this.replaceText(this.evaluateDetail.teacherComment)
      if (this.evaluateDetail.schoolTeacherComment) this.evaluateDetail.schoolTeacherComment = this.replaceText(this.evaluateDetail.schoolTeacherComment)
      // 初始化个人表现、平均表现、完成时长
      this.evaluateDetail.classroomPerformance = this.formatNum(this.evaluateDetail.classroomPerformance)
      this.evaluateDetail.classAveragePerformance = this.formatNum(this.evaluateDetail.classAveragePerformance)
      this.evaluateDetail.completeCostTime = this.formatNum(this.evaluateDetail.completeCostTime ? this.evaluateDetail.completeCostTime : 0, 'isCompleteTime')
      // 初始化勋章等级
      if (this.evaluateDetail.classroomPerformance < 5) {
        this.currentMedal = {
          url: this.medalList[0],
          name: ''
        }
      } else if (this.evaluateDetail.classroomPerformance < 7.5) {
        this.currentMedal = {
          url: this.medalList[1],
          name: '康格鲁勋章'
        }
      } else if (this.evaluateDetail.classroomPerformance < 9.5) {
        this.currentMedal = {
          url: this.medalList[2],
          name: '冯诺依曼勋章'
        }
      } else if (this.evaluateDetail.classroomPerformance < 10) {
        this.currentMedal = {
          url: this.medalList[3],
          name: '洛夫莱斯勋章'
        }
      } else {
        this.currentMedal = {
          url: this.medalList[4],
          name: '图灵勋章'
        }
      }
      // 将后端拉到的作品以及课例进行整理使用
      if (this.evaluateDetail.pointPlatform === 'kitten') {
        this.evaluateDetail.workUrl && this.workList.student.push({
          name: this.evaluateDetail.workName,
          url: ''
        })
      }
      if (this.evaluateDetail.goalList.length > 0) {
        this.workList.goal = this.evaluateDetail.goalList
      }
      // 如果没有学生作品，则将初始tab切换成课例
      this.currentTab = this.workList.student.length ? 'student' : 'goal'

      // 初始化创作分析图表数据
      if (this.evaluateDetail.workAnalyzeShow && JSON.stringify(this.evaluateDetail.eventMap) !== '{}') {
        for (const item in this.evaluateDetail.eventMap) {
          this.analyzeChart.push({
            name: item,
            count: Number(this.evaluateDetail.eventMap[item])
          })
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  width: 100%
  min-height: 100%
  background-color: #3F8EFF
  padding-bottom: 27px
  .bottom-bg
    width: 100%
    height: 90px
    background: url('https://education.codemao.cn/27/public-edu/1/bottom-bg@2x.png') center /contain no-repeat
  .padding-box
    padding: 0 20px 28px
  .banner
    width: 100%
    height: 372px
    background: #3F8EFF linear-gradient(360deg,rgba(63,142,255,1) 0%,rgba(70,23,239,1) 100%);
    position: relative
    .star-bg
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      background: url('https://education.codemao.cn/27/public-edu/1/start@2x.png') center / cover
    .light-bg
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      background: url('https://education.codemao.cn/27/public-edu/1/light@2x.png') center 10px / cover
    .medal
      width: 150px
      height: 172px
      position: absolute
      top: 50%
      left: 50%
      transform translate(-50%, -50%)
      .no-medal
        display: block
        margin: 15px auto 0
        width: 110px
    .banner-title
      width: 120px
      height: 60px
      position: absolute
      top: 0
      left: 5px
      background: url('https://education.codemao.cn/27/public-edu/1/banner-title@2x.png') center / contain no-repeat
    .avatar
      position: absolute
      top: 12px
      right: 20px
      width: 40px
      height: 40px
      border-radius: 50%
      overflow: hidden
      .avatar-img
        width: 100%
        height: 100%
    .score
      position: absolute
      top: 12px
      right: 65px
      padding: 0 8px
      border-radius: 20px
      height: 40px
      line-height: 40px
      background-color: #3F8EFF
      font-size: 24px
      color: #fff
      font-weight: 500
    .student-info
      position: absolute
      bottom: 25px
      left: 50%
      transform: translateX(-50%)
      width: 300px
      font-size: 16px
      font-weight: 300
      line-height: 21px
      color: #ffffff
      letter-spacing: 1px
      .is-bold
        font-weight: 600
      .medal-name
        color: rgb(235, 220, 100)
        font-weight: 600
  .class-info
    width: 100%
    margin-bottom: 20px
    border: 6px solid #A7CBFF
    border-radius: 10px
    position: relative
    .couple
      position: absolute
      top: -27px
      left: 50%
      transform translateX(-50%)
      width: 70px
      height: 27px
      background: url('https://education.codemao.cn/27/public-edu/1/couple@2x.png') center / cover
    .content-wrap
      width: 100%
      height: 100%
      padding: 16px 18px 36px
      border-radius: 5px
      background-color: #fff
      background-image: linear-gradient(90deg, #D9E8FF 10%, rgba(0, 0, 0, 0) 10%), linear-gradient(#D9E8FF 10%, rgba(0, 0, 0, 0) 10%);
      background-size: 10px 10px;
      position: relative
      .content
        font-size: 14px
        color: #0555C8
        letter-spacing: 2px
        line-height: 20px
        font-weight: 500
        word-wrap: break-word
        word-break: normal
        margin-bottom: 0
      .pencil
        position: absolute
        bottom: 20px
        right: 3px
        width: 50px
        height: 24px
        background: url('~@/assets/images/pencil.png') center / cover no-repeat
.class-work
  width: 100%
  margin-bottom: 20px
  background-color: #fff
  border-radius: 10px
  padding: 10px 5px
  display: flex
  flex-direction column
  justify-content: center
  .square-list
    height: 10px
    background-image: linear-gradient(90deg, #D9E8FF 50%, rgba(0, 0, 0, 0) 50%);
    background-size: 20px 10px;
  .switch-tab
    margin: 20px auto 24px
    display: inline-flex
    align-items: center
    justify-content: space-between
    height: 28px
    border-radius: 14px
    background-color: rgba(63,142,255,.15)
    .tab
      display: inline-block
      width: 95px
      height: 100%
      text-align: center
      font-size: 16px
      color: #3f8eff
      font-weight: 500
      line-height: 28px
      &.active
        background-color: #3F8EFF
        border-radius: 14px
        color: #ffffff
  .list-wrap
    width: 100%
    overflow-x: scroll
    margin-bottom: 10px
    &::-webkit-scrollbar
      display: none
    .work-list
      display: flex
      margin-left: 23px
    .work-li
      margin-right: 10px
    .work
      width: 280px
      height: 180px
      border-radius: 10px
      position: relative
      overflow: hidden
      background: url('~@/assets/images/kitten_student.png') center / cover no-repeat
      margin-bottom: 5px
      .mask
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-color: rgba(0, 0, 0, .2)
        .play-icon
          position: absolute
          top: 50%
          left: 50%
          transform: translate(-50%, -50%)
          width: 23px
          height: 29px
          background: url('~@/assets/images/evaluate_play.png') center / cover
  .work-name
    width: 280px
    display: flex
    justify-content space-between
    margin: 0
    padding-right: 7px
    .name-title
      display: inline-block
      width: 50%
      color: #333
      font-size: 16px
      font-weight: 500
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
    .name
      display: inline-block
      width: 50%
      font-size: 14px
      color: #333
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      text-align: right
.create-analyze
  width: 100%
  padding: 10px 0 24px
  background-color: #fff
  border-radius: 10px
  margin-bottom: 20px
  .title
    .expression-icon
      background: url('https://education.codemao.cn/27/public-edu/1/statistics@2x.png') center 3px / cover no-repeat
  .analyze-content
    background-color: #EEF5FF
    border-radius: 6px
    padding: 8px 5px
    width: 300px
    margin: 0 auto
    letter-spacing: 2px
    line-height: 20px
    .is-blue
      color: #3f8eff
  .avg-content
    color: #333
    font-size: 14px
    letter-spacing: 2px
    line-height: 20px
    margin-top: 15px
    padding: 0 16px 0 32px
    position: relative
    &::after
      position: absolute
      top: 7px
      left: 20px
      content: ''
      width: 8px
      height: 8px
      border-radius: 50%
      background-color: #00ef68
.class-expression
  width: 100%
  padding: 10px 0 0
  margin-bottom: 20px
  background-color: #fff
  border-radius: 10px
  overflow: hidden
  .chart-wrap
    background-color: #fff
    border-radius: 10px
    padding-bottom: 10px
  .expression-wrap
    display: flex
    padding: 30px 20px 18px
    justify-content space-between
    background-color: #EEF5FF
    .expression
      color: #333
      .score
        font-size: 36px
        font-weight: 500
        line-height: 1
        color: #3f8eff
        span
          font-size: 12px
          font-weight: 300
          margin-left: 7px
          color: #333
      .desc
        font-size: 14px
        margin-bottom: 0
        margin-top: 0
.class-evaluate
  width: 100%
  background-color: #fff
  border-radius: 10px
  padding-top: 10px
  .title
    .expression-icon
      background: url('https://education.codemao.cn/27/public-edu/1/class-info@2x.png') center / cover
  .evaluate-wrap
    background-color: #fff
    border-radius: 10px
    padding: 15px 20px 32px 8px
    font-size: 12px
    .evaluate-detail-mlz, .evaluate-detail-class
      position: relative
      padding-left: 60px
    .mlz-evaluate, .class-teacher-evaluate
      font-weight: 500
      color: #333
      position: absolute
      top: 0
      left: 0
      padding-top: 35px
      width: 50px
      text-align: center
      background: url('https://education.codemao.cn/27/public-edu/1/mlz-teacher@2x.png') top center / 38px 35px no-repeat
    .class-teacher-evaluate
      background: url('https://education.codemao.cn/27/public-edu/1/class-teacher@2x.png') top center / 38px 35px no-repeat
    .content
      width: 250px
      line-height: 17px
      color: #0555C8
      font-weight: 400
      margin-bottom: 0
      word-wrap: break-word
      word-break: normal
      background-color: #EEF5FF
      border-radius: 5px
      padding: 12px
      position: relative
      min-height: 53px
      &::after
        content: ''
        width: 10px
        height: 10px
        transform: skew(135deg)
        position: absolute
        top: 10px
        left: -5px
        background-color: #EEF5FF
.work-wrap
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  background-color: rgba(0, 0, 0, .7)
  z-index: 10
  iframe
    position: absolute
    top: 50%
    left: 0
    transform translateY(-50%)
    width: 100%
    height: 80%
    background-color: #fff
    z-index: 2
  img
    position: absolute
    top: 50%
    left: 50%
    transform translate(-50%, -50%)
    max-width: 100%
    z-index: 2
  .word-tip
    position: absolute
    width: 100%
    text-align: center
    top: 3%
    left: 50%
    transform: translateX(-50%)
    color: #fff
    font-size: 16px
    z-index: 1
.title
  margin-bottom: 10px
  display: flex
  align-items: center
  justify-content: center
  line-height: 30px
  position: relative
  .expression-icon
    display: inline-block
    width: 30px
    height: 30px
    background: url('https://education.codemao.cn/27/public-edu/1/class-expression@2x.png') center / cover
    margin-right: 7px
  .title-desc
    font-size: 18px
    color: #3F8EFF
    font-weight: 600
    z-index: 1
  .word-bg
    position: absolute
    width: 72px
    height: 12px
    top: 40%
    left: 45%
    background-color: #FFF38C
.dashed
  width: 100%
  height: 1px
  background-image: linear-gradient(90deg, #3F8EFF 50%, rgba(0, 0, 0, 0) 50%)
  background-size: 15px 1px
  position: relative
  margin-bottom: 10px
  &::after
    content: ''
    position: absolute
    top: 50%
    left: -7.5px
    transform translateY(-50%)
    width: 15px
    height: 15px
    border-radius 50%
    background-color: #3F8EFF
  &::before
    content: ''
    position: absolute
    top: 50%
    right: -7.5px
    transform translateY(-50%)
    width: 15px
    height: 15px
    border-radius 50%
    background-color: #3F8EFF
</style>
<style>
  html, body, #app {
    overflow: scroll;
  }
</style>
